import { render, staticRenderFns } from "./modal-multiple-brands.vue?vue&type=template&id=1b76476e&scoped=true&lang=pug"
import script from "./modal-multiple-brands.js?vue&type=script&lang=js&external"
export * from "./modal-multiple-brands.js?vue&type=script&lang=js&external"
import style0 from "./modal-multiple-brands.vue?vue&type=style&index=0&id=1b76476e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b76476e",
  null
  
)

export default component.exports